import styled, { css } from 'styled-components';
import { mobile } from '../mixins/media';
import type { ModalBodyVariant } from './type';

export const Overlay = styled.div<{ isTransparent: boolean; zIndex?: string; background?: string }>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${props =>
        props.background ||
        (props.isTransparent ? props.theme.overlay.background : props.theme.overlay.notTransparentBackground)};
    z-index: ${props => (props.zIndex ? props.zIndex : '9998')};
`;

export const Content = styled.div<{ variant?: ModalBodyVariant; width?: string; zIndex?: string }>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: ${props => (props.zIndex ? props.zIndex : 9999)};
    pointer-events: none;

    > * {
        pointer-events: auto;
    }

    ${mobile`
        width: 100%;
    `}

    ${props =>
        props.width &&
        `
        width: ${props.width};
    `}

    ${props =>
        props.variant === 'full-width' &&
        css`
            display: flex;
            width: 100%;
            height: 100%;
        `}
`;
